var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"app-input-text",style:({
    height: `${_vm.height}px`
  }),attrs:{"type":"text"},domProps:{"value":_vm.text},on:{"input":_vm.inputed}})
}
var staticRenderFns = []

export { render, staticRenderFns }